import React, { useEffect, useState } from 'react';
import { Box, TextField, Chip, Typography, Checkbox, FormControlLabel } from '@mui/material';

const filterConfigs = {
  establishment_list: [
    {
      type: 'number',
      label: 'Raio de distância (km)',
      field: 'geoRadius',
      convertToMeters: true,
      inputProps: { min: 0 },
      defaultValue: 0,
    },
    {
      type: 'boolean',
      label: 'Apenas com promoções',
      field: 'hasPromo',
      component: 'checkbox',
      defaultValue: false,
    },
  ],
  promotion_list: [
    {
      type: 'number',
      label: 'Raio de distância (km)',
      field: 'geoRadius',
      convertToMeters: true,
      inputProps: { min: 0 },
      defaultValue: 0,
    },
    {
      type: 'boolean',
      label: 'Apenas com cupom',
      field: 'hasVoucher',
      component: 'checkbox',
      defaultValue: false,
    },
  ],
  product_list: [
    {
      type: 'number',
      label: 'Raio de distância (km)',
      field: 'geoRadius',
      convertToMeters: true,
      inputProps: { min: 0 },
      defaultValue: 0,
    },
  ],
};

export default function Filter({ cardType, onFiltersChange, infosForEdit }) {
  const [filters, setFilters] = useState({});

  // Inicializa os filtros com valores padrão ou do infosForEdit
  useEffect(() => {
    const initialFilters = {};

    filterConfigs[cardType].forEach((filter) => {
      // Valor padrão do filtro
      let value = filter.defaultValue;

      // Verifica se tem valor no infosForEdit
      if (infosForEdit?.storePlacesQuery) {
        // GeoRadius está no root do storePlacesQuery
        if (filter.field === 'geoRadius' && infosForEdit.storePlacesQuery.geoRadius) {
          value = infosForEdit.storePlacesQuery.geoRadius;
        }
        // HasPromo está no root do storePlacesQuery
        else if (
          filter.field === 'hasPromo' &&
          infosForEdit.storePlacesQuery.hasPromo !== undefined
        ) {
          value = infosForEdit.storePlacesQuery.hasPromo;
        }
        // HasVoucher está no root do storePlacesQuery
        else if (
          filter.field === 'hasVoucher' &&
          infosForEdit.storePlacesQuery.hasVoucher !== undefined
        ) {
          value = infosForEdit.storePlacesQuery.hasVoucher;
        }
      }

      initialFilters[filter.field] = value;
    });

    setFilters(initialFilters);
    onFiltersChange(initialFilters);
  }, [cardType, infosForEdit]);

  const handleFilterChange = (field, value) => {
    const updatedFilters = { ...filters };
    const filterConfig = filterConfigs[cardType].find((f) => f.field === field);

    // Aplica conversão de KM para metros se necessário
    if (filterConfig?.convertToMeters) {
      value = value !== null ? parseFloat(value) * 1000 : filterConfig.defaultValue;
    }

    // Atualiza o valor (null mantém o padrão)
    updatedFilters[field] = value !== null ? value : filterConfig?.defaultValue;

    setFilters(updatedFilters);
    onFiltersChange(updatedFilters);
  };

  const renderFilterInput = (filter) => {
    switch (filter.type) {
      case 'number':
        return (
          <TextField
            fullWidth
            type="number"
            label={filter.label}
            value={
              filters[filter.field] !== 0
                ? filters[filter.field]
                  ? filters[filter.field] / 1000
                  : ''
                : ''
            }
            onChange={(e) => {
              const inputValue = e.target.value;
              // Se o campo estiver vazio ou for um número válido
              if (inputValue === '' || !isNaN(inputValue)) {
                handleFilterChange(filter.field, inputValue === '' ? null : inputValue);
              }
            }}
            inputProps={filter.inputProps}
          />
        );

      case 'boolean':
        return (
          <FormControlLabel
            control={
              <Checkbox
                checked={!!filters[filter.field]}
                onChange={(e) => handleFilterChange(filter.field, e.target.checked)}
              />
            }
            label={filter.label}
          />
        );

      default:
        return null;
    }
  };

  return (
    <Box sx={{ mt: 3, p: 2, border: '1px solid #eee', borderRadius: 1 }}>
      <Typography variant="subtitle1" gutterBottom>
        Filtros:
      </Typography>

      {/* Filtros ativos (chips) */}
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
        {Object.entries(filters)
          .filter(([field]) => {
            const filter = filterConfigs[cardType].find((f) => f.field === field);
            return filter;
          })
          .map(([field, value]) => {
            const filter = filterConfigs[cardType].find((f) => f.field === field);
            if (!filter) return null;

            let displayValue = value;
            if (filter.convertToMeters) {
              displayValue = `${value / 1000} km`;
            } else if (filter.type === 'boolean') {
              displayValue = value ? 'Sim' : 'Não';
            }

            return (
              <Chip
                key={field}
                label={`${filter.label}: ${displayValue}`}
                onDelete={() => handleFilterChange(field, null)}
              />
            );
          })}
      </Box>

      {/* Formulário de filtros */}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        {filterConfigs[cardType].map((filter) => (
          <Box key={filter.field}>{renderFilterInput(filter)}</Box>
        ))}
      </Box>
    </Box>
  );
}
